import React from 'react'
import { getRelativeServiceBasePath } from '../../../../global/environments/path'

function Loader({ showBackground = true }) {
  return (
    <div
      className={'details-bg' + (showBackground ? ' u-bgColorOffwhite' : '')}
    >
      <div className="u-sizeConstrained">
        <div className="u-padding6gu u-marginBottom4gu">
          <div className="section-content u-textCenter">
            <img
              src={
                getRelativeServiceBasePath() +
                `/webfiles/latest/assets/cti/images/cti-page-loader-icon.gif`
              }
              alt="Loading"
            />
          </div>
        </div>
      </div>
    </div>
  )
}

export default Loader
